export const TransactionStatusMapEnum = [
  { value: 'Created', title: 'Created' },
  { value: 'Pending', title: 'Pending' },
  { value: 'Authorized', title: 'Authorized' },
  { value: 'Posted', title: 'Posted' },
  { value: 'Captured', title: 'Accepted' }, // Accepted = Captured
  { value: 'Approved', title: 'Approved' },
  { value: 'Success', title: 'Success' },
  { value: 'SwipeInitiated', title: 'Swipe Initiated' },
  { value: 'SwipeCanceled', title: 'Swipe Canceled' },
  { value: 'Failed', title: 'Failed' },
  { value: 'Denied', title: 'Denied' },
  { value: 'CancelAttempt', title: 'Cancel Attempted' },
  { value: 'Cancelled', title: 'Cancelled' },
  { value: 'RefundAttempt', title: 'Refund Attempted' },
  { value: 'Refunded', title: 'Refunded' },
  { value: 'Hold', title: 'Hold' },
  { value: 'Returned', title: 'Returned' },
  { value: 'Chargeback', title: 'Chargeback' },
  { value: 'SettlementHold', title: 'Settlement hold' },
  { value: 'Retried', title: 'Retried' },
  { value: 'ReprocessAttempt', title: 'Reprocess Attempted' },
  { value: 'Reprocessed', title: 'Reprocessed' },
  { value: 'PartialApproved', title: 'Partial Approved' },
  { value: 'PartiallyCaptured', title: 'Partially Accepted' },
  { value: 'PartiallyReturned', title: 'Partially Returned' },
  { value: 'PartialReturnRequested', title: 'Partial Return Requested' },
  { value: 'Closed', title: 'Closed' },
  { value: 'Deleted', title: 'Deleted' },
  { value: 'Unknown', title: 'Unknown' },
];